import ShadowExcalamationIcon from "@/shared/icons/shadow-exclamation";
import { ThirdPartyVendorLayout } from ".";

const ThirdPartyFormExpiredScreen = ({ contact_email }: { contact_email: string }) => {
  return <ThirdPartyVendorLayout>
    <div className="w-full flex flex-col">
      <div className="grow overflow-hidden rounded-xl">

        <div className="w-full h-screen bg-[#FAFAFA] bg-opacity-100 flex flex-col items-center justify-center">
          <div className="flex items-center justify-center">
            <ShadowExcalamationIcon className="w-64 h-64" />
          </div>
          <div className="w-full flex flex-col items-center justify-center gap-4">
            <h2 className="text-lg">Link Expired</h2>
            <span>
              Please contact <a href={`mailto:${contact_email}`} className="text-blue-600">{contact_email}</a> to request a new link and restart the process.
            </span>
          </div>
        </div>

      </div>
    </div>
  </ThirdPartyVendorLayout>
}

export default ThirdPartyFormExpiredScreen;